import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import './VerifyEmail.scss';
import AuthLayout from '@/layouts/AuthLayout';

const VerifyEmail = ({ email }) => (
    <AuthLayout>
        <div className="verify-prompt">
            <CheckCircle size={52} strokeWidth={1.5} className="verify-prompt-icon" />
            <h3>Verify your Email</h3>
            <p className="verify-prompt-sub">Please check your email!</p>
            <p className="verify-prompt-body">
                An email has been sent to <strong>{email}</strong> for confirmation.
                Click the link in the email to activate your account.
            </p>
            <div className="auth-footer">
                <Link to="/login" className="auth-footer-text">
                    <ArrowLeft size={13} style={{ display: 'inline', marginRight: '4px' }} />
                    <span>Back to Sign In</span>
                </Link>
            </div>
        </div>
    </AuthLayout>
);

export default VerifyEmail;